import xhr from "../../Helper/axiosInterceptor";

import {
  baseUrl,
  URL_UPLOAD_FILE_CLAIM,
  URL_INVOICE_LIST,
  URL_CLAIM_LIST,
  URL_CLAIM_PENDING_LIST,
  URL_CLAIM_DETAIL_PENDING,
  URL_CLAIM_STATUS,
  URL_CLAIM_DOC,
  URL_CREATE_INVOICE,
  URL_DELETE_DOC_CLAIM,
} from "../../Config/Api";

export const uploadFileClaim = (data, onProgress) => {
  const formData = new FormData();
  formData.append("claimId", data.claimId);
  formData.append("invoiceId", data.invoiceId);
  formData.append("uploadBy", data.uploadBy);

  data.files.forEach((f) => {
    formData.append("files", f);
  });

  return xhr(
    URL_UPLOAD_FILE_CLAIM + `/${data.id}`,
    "post",
    formData,
    {},
    0,
    null,
    true,
    onProgress
  );
};
export const invoiceList = (data) => {
  return xhr(URL_INVOICE_LIST, "get", null, undefined, undefined, data);
};

export const claimList = (data) => {
  return xhr(URL_CLAIM_LIST, "get", null, undefined, undefined, data);
};

export const claimPendingList = (data) => {
  return xhr(
    `${URL_CLAIM_PENDING_LIST}/${data.clinicId}/${data.id}`,
    "get"
  );
};

export const claimDetail = (data) => {
  return xhr(
    URL_CLAIM_DETAIL_PENDING.replace("param1", data.rocNo)
      .replace("param2", data.clinicId)
      .replace("param3", data.id),
    "get",
    {}
  );
};

export const claimStatus = (data) => {
  return xhr(URL_CLAIM_STATUS, "get", null, undefined, undefined, data);
};

export const claimDoc = (data) => {
  return xhr(URL_CLAIM_DOC, "get");
};

export const createInvoice = (data) => {
  return xhr(URL_CREATE_INVOICE, "post", data);
};

export const deleteDocClaim = (data) => {
  return xhr(URL_DELETE_DOC_CLAIM, "delete", data);
};

export const readNotificationClaim = (claimId, userId) => {
  return xhr(
    `${baseUrl}/claim/notifications/${claimId}/read`,
    "patch",
    null,
    undefined,
    undefined,
    { id: userId }
  );
};

export const readAllNotificationsClaim = (userId) => {
  return xhr(
    `${baseUrl}/claim/notifications/read`,
    "patch",
    null,
    undefined,
    undefined,
    { id: userId }
  );
};
